<template>
  <div class="home" style="padding-bottom: 60px">
    <div class="main___ut85X">
      <div class="">
        <div class="header-content___2V1fN"></div>
        <div class="main___2Urec">
          <div class="infoContent___83STh">
            <div class="infoBox___FGFO1">
              <div class="topContent___2uXHw">
                <div class="basicContent___QgPZS">
                  <div class="nameBox___nin8K">
                    <h1>郑明香</h1>
                    <!-- <div class="status___2lfi3">待岗</div> -->
                  </div>
                  <div class="info___18IXs">年龄: 54岁</div>
                  <div class="info___18IXs">保姆、家政员、白班阿姨、育婴师</div>
                </div>
                <div class="imgContent___1Qia7">
                  <img class="bgImg___fpXKW" :src="require('@/assets/ava.png')" alt="" />
                </div>
              </div>
              <div class="infoList___3ul_p">
                <div class="infoItem___3Pg7P">
                  <div class="circle___2yOx-"></div>
                  经验： 8年
                </div>
                <div class="infoItem___3Pg7P">
                  <div class="circle___2yOx-"></div>
                  籍贯： 湖南人
                </div>
                <div class="infoItem___3Pg7P">
                  <div class="circle___2yOx-"></div>
                  学历： 初中
                </div>
                <div class="infoItem___3Pg7P">
                  <div class="circle___2yOx-"></div>
                  星座： 天秤座
                </div>
                <div class="infoItem___3Pg7P">
                  <div class="circle___2yOx-"></div>
                  民族： 汉族
                </div>
                <div class="infoItem___3Pg7P">
                  <div class="circle___2yOx-"></div>
                  属相： 狗
                </div>
                <div class="infoItem___3Pg7P" style="width: 100%">
                  <div class="circle___2yOx-"></div>
                  联系电话： 13874361538
                </div>
              </div>
              <div class="tagList___1_EJZ"></div>
            </div>
          </div>
          <div class="cardBox3___2xwn8">
            <div class="headerBox___3w0Mo">
              <div class="title___Lmzky">
                <div class="name___1Py85">- 个人信息 -</div>
                <!-- <span class="bgText___KOeHI">INFORMATION</span> -->
              </div>
            </div>
            <div class="content___KUy2C userInfo___2UsAO">
              <div class="infoBox___FGFO1">
                <div class="item___-YmsT">
                  <div class="label___31bZu">性　　别：</div>
                  <div class="value___1zuTU">女</div>
                </div>
                <div class="item___-YmsT">
                  <div class="label___31bZu">婚姻状况：</div>
                  <div class="value___1zuTU">已婚</div>
                </div>
                <div class="item___-YmsT">
                  <div class="label___31bZu">语　　言：</div>
                  <div class="value___1zuTU">普通话</div>
                </div>
                <!-- <div class="item___-YmsT">
                  <div class="label___31bZu">编　　号：</div>
                  <div class="value___1zuTU">000216</div>
                </div> -->
              </div>
              <div class="auntBox___1RgaH">
                <div class="list___2F7IE">
                  <div class="label___31bZu">专业技能：</div>
                  <div class="value___1zuTU">中餐、家常菜、面食、湘菜、煲汤、海鲜、做家务、做饭好吃、煲汤</div>
                </div>
                <div class="list___2F7IE">
                  <div class="label___31bZu">自我简介：</div>
                  <div class="value___1zuTU">
                    本人经过正规专业的母婴护理和岗前培训，主要照料、护理并让宝宝养成一个良好的生活习惯并健康快乐成长！会母婴护理，母乳喂养指导。<br />
                    本人没有特别的爱好，但诚实守信、直爽、做事认真、吃苦耐劳、尊老爱幼，尽心尽责为雇主提供优质的服务，以雇主满意为宗旨。让雇主放心、省心、安心。
                  </div>
                </div>
              </div>
              <div class="list___2F7IE">
                <div class="label___31bZu">住家情况：</div>
                <div class="value___1zuTU">住家</div>
              </div>
              <!-- <div class="list___2F7IE">
                <div class="label___31bZu">所在门店：</div>
                <div class="value___1zuTU">深圳市优享生活服务有限公司</div>
              </div> -->
              <div class="list___2F7IE">
                <div class="label___31bZu">常驻地址：</div>
                <div class="value___1zuTU">广东东莞、广东深圳</div>
              </div>
            </div>
          </div>
          <div class="card-list___KyyS5">
            <div class="headerBox___3w0Mo">
              <div class="title___Lmzky">
                <div class="name___1Py85">- 工作经历 -</div>
                <!-- <span class="bgText___KOeHI">WORK</span> -->
              </div>
            </div>
            <div class="conBox___11S5A">
              <div class="con___2VAjm">
                <div class="title___Lmzky">2017年01月-至今</div>
                <div class="text___2Xfyk">
                  性格特点：温柔体贴、极具亲和力、善于沟通、责任心强、勤快善良 ，有爱心。喜欢宝宝<br />
                  <br />
                  职业特长：经过专业培训，高级育婴师，会产妇、新生儿护理，有爱心，带宝宝超级有耐心。超级会带宝宝和宝宝互动，会和宝宝玩游戏
                  ，会辅导孩子， 做家常菜煲汤，各种口味 。<br />
                  <br />
                  烹饪技能:会炒菜，会煲汤，做饭好吃，辣菜，湘菜，会做各种家常饭菜。<br />
                  <br />
                  工作经验:8年<br />
                  2017年9月—2019年3月在东莞带3个月宝宝到一岁半，照顾宝宝的饮食起居，辅食添加协助家务。2019年4月—2021年8月在深圳罗湖带6个月宝宝到2岁。<br />
                  2021年9月—2023年9月在东莞樟木头带一岁宝宝到三岁上幼儿园下学。<br />
                  2024年全年：多次顶班照看梅州老人的饮食起居。深圳照顾小朋友饮食起居，照看上下学。<br />
                  2025年—2026年：任职于花都一企业后勤服务岗位，全面负责员工日常膳食烹饪（日均三餐菜样十个以上）与办公场所清洁工作。<br />
                  工作意向:、高级育婴师，做饭搞卫生，收纳整理。
                </div>
              </div>
            </div>
          </div>
          <div class="img-model">
            <span class="title-text">- 饮食料理展示 -</span>

            <div class="img-wrapper">
              <img class="img-view" :src="item" alt="" v-for="(item, index) in imglist" :key="index"
                @click="previewImg(imglist, index)" />
              <!-- <div class="video-view" v-for="(item, i) in videoList" :key="i" @click="playVideo(item)">
                <img class="img-icon" :src="require('@/assets/video_play.png')" alt="" />
                <img class="img-view" :src="item.img" alt="" />
              </div> -->
            </div>
            <span class="title-text">- 个人生活照 -</span>

            <div class="img-wrapper">
              <img class="img-view" :src="item" alt="" v-for="(item, index) in imglist10" :key="index"
                @click="previewImg(imglist10, index)" />

            </div>
            <span class="title-text">- 照顾小宝宝 -</span>

            <div class="img-wrapper">
              <img class="img-view" :src="item" alt="" v-for="(item, index) in imglist11" :key="index"
                @click="previewImg(imglist11, index)" />
              <div class="video-view" v-for="(item, i) in videoList" :key="i" @click="playVideo(item)">
                <img class="img-icon" :src="require('@/assets/video_play.png')" alt="" />
                <img class="img-view" :src="item.img" alt="" />
              </div>
            </div>
            <span class="title-text">- 照顾老人 -</span>

            <div class="img-wrapper">
              <div class="video-view" v-for="(item, i) in videoList2" :key="i" @click="playVideo(item)">
                <img class="img-icon" :src="require('@/assets/video_play.png')" alt="" />
                <img class="img-view" :src="item.img" alt="" />
              </div>
            </div>
            <span class="title-text">- 陪伴小朋友玩耍 -</span>

            <div class="img-wrapper">
              <div class="video-view" v-for="(item, i) in videoList3" :key="i" @click="playVideo(item)">
                <img class="img-icon" :src="require('@/assets/video_play.png')" alt="" />
                <img class="img-view" :src="item.img" alt="" />
              </div>
            </div>
          </div>
          <div class="img-model">
            <span class="title-text">- 职业资格照片 -</span>
            <div class="img-wrapper">
              <img class="img-view" :src="item" alt="" v-for="(item, index) in imglist2" :key="index"
                @click="previewImg(imglist2, index)" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="video-box">
      <video
        muted="muted"
        id="startvideo1"
        class="video"
        :src="'https://media.jiazhengye.cn/d87944d5-1d93-4371-9dcc-2c556286413f_avthumb'"
        type="video/mp4"
        :poster="require('@/assets/1.jpg')"
        autoplay="autoplay"
        controls="controls"
        loop="-1"
      >
        <p>你的浏览器不支持video标签.</p>
      </video>
    </div> -->

    <div class="lianxi">
      <a href="tel:13874361538">点击联系我</a>
    </div>

    <van-popup v-model="show">
      <div class="video-wrapper" v-if="show">
        <video muted="muted" id="startvideo1" class="video" :src="actViedo" type="video/mp4" autoplay="autoplay"
          controls="controls" loop="-1">
          <p>你的浏览器不支持video标签.</p>
        </video>
      </div>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import { ImagePreview } from 'vant'
export default {
  name: 'HomeView',
  components: {
    HelloWorld
  },
  data() {
    return {
      imglist: [
        require('@/assets/1.jpg'),
        require('@/assets/10.jpg'),
        require('@/assets/4.jpg'),
        require('@/assets/5.jpg'),
        require('@/assets/12.jpg'),
        require('@/assets/13.jpg'),
        // require('@/assets/2.jpg'), 
        require('@/assets/3.jpg'),
        require('@/assets/17.png'),
        // require('@/assets/6.jpg'),
        // require('@/assets/11.jpg'),
        // require('@/assets/14.jpg'),
        // require('@/assets/15.jpg'),
        // require('@/assets/16.jpg')
        // require('@/assets/7.jpg')
      ],
      imglist10: [

        require('@/assets/14.jpg'),
        require('@/assets/15.jpg'),
        require('@/assets/16.jpg')
        // require('@/assets/7.jpg')
      ],
      imglist11: [
        require('@/assets/6.jpg'),
        require('@/assets/11.jpg'),

        // require('@/assets/7.jpg')
      ],
      imglist2: [
        require('@/assets/z1.jpg'),
        require('@/assets/z3.jpg'),
        require('@/assets/z2.jpg'),
        require('@/assets/z4.jpg'),
        require('@/assets/z5.jpg')
      ],
      videoList: [
        { img: require('@/assets/v1.png'), url: require('@/assets/1.mp4') },
        // { img: require('@/assets/v2.png'), url: require('@/assets/2.mp4') },
        // { img: require('@/assets/v3.png'), url: require('@/assets/3.mp4') },
      ],
      videoList2: [
        // { img: require('@/assets/v1.png'), url: require('@/assets/1.mp4') },
        { img: require('@/assets/v2.png'), url: require('@/assets/2.mp4') },
        { img: require('@/assets/v3.png'), url: require('@/assets/5.mp4') },
      ], videoList3: [
        { img: require('@/assets/v4.png'), url: require('@/assets/4.mp4') },
        // { img: require('@/assets/v2.png'), url: require('@/assets/2.mp4') },
        // { img: require('@/assets/v3.png'), url: require('@/assets/3.mp4') },
      ],
      show: false,
      actViedo: ''
    }
  },
  methods: {
    previewImg(list, i) {
      console.log(list, i)
      ImagePreview({
        images: list,
        startPosition: i
      })
    },
    playVideo(item) {
      console.log(item)
      this.actViedo = item.url
      this.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.main___3BEcZ {
  display: flex;
  flex-wrap: wrap;
}

.main___3BEcZ .img___3n4eG,
.main___3BEcZ .videoBox___3ef3l {
  width: 27.333vw;
  height: 27.333vw;
  background: #d8d8d8;
  border-radius: 1.6vw;
  margin: 2.133vw 0 0 2vw;
  object-fit: cover;
}

.main___3BEcZ .img1___3iu4k {
  width: 27.067vw;
  height: 27.067vw;
}

.main___3BEcZ .img2___1KruA {
  width: 18.667vw;
  height: 18.933vw;
  background: #d8d8d8;
  border-radius: 1.067vw;
  margin: 1.6vw 1.6vw 0 0;
}

.main___3BEcZ .videoBox___3ef3l {
  position: relative;
}

.main___3BEcZ .videoBox___3ef3l .videoImg___2SVV4 {
  width: 100%;
  height: 100%;
  border-radius: 1.6vw;
}

.main___3BEcZ .videoBox___3ef3l .playIcon___2JIZO {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10.667vw;
  height: 10.667vw;
}

.customeBox___VtvgC {
  padding: 1.067vw 5.333vw 4.267vw;
}

.customeBox___VtvgC .listBox___q_eMx {
  margin-top: 3.2vw;
}

.customeBox___VtvgC .header___jZSSX {
  display: flex;
  align-items: center;
}

.customeBox___VtvgC .header___jZSSX .headerImg___3nL0s {
  width: 9.467vw;
  height: 9.467vw;
  background: #d8d8d8;
  border-radius: 50%;
  object-fit: cover;
}

.customeBox___VtvgC .header___jZSSX .name___3WCOS {
  flex: 1 1;
  font-size: 4.267vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 6vw;
  margin-left: 2.133vw;
}

.customeBox___VtvgC .header___jZSSX .time___3RqMj {
  font-size: 3.2vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #8d8e99;
  line-height: 4.4vw;
}

.customeBox___VtvgC .content___3Pn4q {
  padding-left: 11.733vw;
}

.customeBox___VtvgC .con___ckLHp {
  padding-bottom: 4.267vw;
  border-bottom: 0.5px solid #ededf0;
}

.customeBox___VtvgC .warn___3kjNV {
  font-size: 4vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff4040;
  line-height: 5.6vw;
  margin-top: 2.4vw;
}

.customeBox___VtvgC .remark___2emKM {
  font-size: 4vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 5.867vw;
  margin-top: 2.133vw;
  word-break: break-all;
  white-space: pre-wrap;
}

.customeBox___VtvgC .starBox___2IrJy {
  display: flex;
  flex-wrap: wrap;
}

.customeBox___VtvgC .starBox___2IrJy .list___3OmKM {
  display: flex;
  align-items: center;
  width: 50%;
}

.customeBox___VtvgC .starBox___2IrJy .label___2vb99 {
  width: 14.667vw;
  font-size: 3.2vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #8d8e99;
  line-height: 4.4vw;
  text-align: justify;
  -moz-text-align-last: justify;
  text-align-last: justify;
  margin-right: 0.667vw;
}

.customeBox___VtvgC .listBox___q_eMx:last-child .con___ckLHp {
  padding-bottom: 0;
  border-bottom: none;
}

.look___2Lybo {
  font-size: 3.2vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1890ff;
  margin-top: 1.6vw;
}

.skilldetail___3KCR_ .item___2xjMu,
.skilldetail___3KCR_ .items___34yRc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.5px solid #e3e3e6;
  padding: 4.667vw 0;
  margin: 0 4.267vw;
}

.skilldetail___3KCR_ .item___2xjMu .left___3I7WA,
.skilldetail___3KCR_ .items___34yRc .left___3I7WA {
  display: flex;
  align-items: center;
}

.skilldetail___3KCR_ .item___2xjMu .left___3I7WA .head___zXMJ6,
.skilldetail___3KCR_ .items___34yRc .left___3I7WA .head___zXMJ6 {
  width: 11.2vw;
  height: 11.2vw;
  border-radius: 50%;
  margin-right: 2.133vw;
}

.skilldetail___3KCR_ .item___2xjMu .left___3I7WA .title___1cvVK,
.skilldetail___3KCR_ .items___34yRc .left___3I7WA .title___1cvVK {
  font-size: 4.267vw;
  font-weight: 700;
}

.skilldetail___3KCR_ .item___2xjMu .left___3I7WA .title___1cvVK .bottom___3KCCj,
.skilldetail___3KCR_ .items___34yRc .left___3I7WA .title___1cvVK .bottom___3KCCj {
  font-weight: 400;
  font-size: 3.733vw;
  color: #5e5e66;
}

.skilldetail___3KCR_ .item___2xjMu .right___1VR6L,
.skilldetail___3KCR_ .items___34yRc .right___1VR6L {
  min-width: 11.467vw;
  min-height: 11.467vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3.2vw;
  font-weight: 700;
  border-radius: 50%;
}

.skilldetail___3KCR_ .item___2xjMu:last-of-type,
.skilldetail___3KCR_ .items___34yRc:last-of-type {
  border: none;
}

.skilldetail___3KCR_ .items___34yRc {
  margin: 0;
}

.skilldetail___3KCR_ .items___34yRc:first-of-type {
  padding-top: 0;
}

.skilldetail___3KCR_ .items___34yRc:last-of-type {
  padding-bottom: 0;
}

.Physical___2C4F_ .pLine___nEba9 {
  border-bottom: 0.5px solid #ededf0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 4.267vw;
  height: 17.067vw;
  font-size: 4.267vw;
  color: #1a1a1a;
  line-height: 4vw;
}

.Physical___2C4F_ .pLine___nEba9 .time___2odG9 {
  font-weight: 400;
  color: #8d8e99;
  font-size: 3.467vw;
  line-height: 4.267vw;
  margin-top: 2vw;
}

.Physical___2C4F_ .pLine___nEba9 .btn___KSOJV {
  width: 17.067vw;
  height: 8.533vw;
  background: #fff;
  border-radius: 1.067vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3.733vw;
}

.Physical___2C4F_ .pLine___nEba9:last-of-type {
  border: none;
}

.Physical___2C4F_ .Three___heqMO {
  margin-top: 4.267vw;
}

.Physical___2C4F_ .Three___heqMO .pLine___nEba9 {
  border: none;
  height: 18.4vw;
  background: #f5f6f9;
  margin-top: 3.2vw;
  padding: 0 4vw;
  border-radius: 1.867vw;
  font-size: 4.267vw;
}

.Physical___2C4F_ .Two___3dqMA .pLine___nEba9 {
  height: 18.4vw;
}

.Physical___2C4F_ .Four___1D1QB,
.Physical___2C4F_ .NewThree___3pi1H {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: -3.2vw;
}

.Physical___2C4F_ .Four___1D1QB .ThreeItem___2EkLR,
.Physical___2C4F_ .NewThree___3pi1H .ThreeItem___2EkLR {
  width: 40vw;
  height: 28vw;
  background: #fff;
  box-shadow: inset 0 0 0 0 rgba(243, 184, 142, 0.5);
  border-radius: 1.067vw;
  border-top: 0.5px solid #fad4b1;
  border-bottom: 0.5px solid #fad4b1;
  margin-top: 3.2vw;
  text-align: center;
}

.Physical___2C4F_ .Four___1D1QB .ThreeItem___2EkLR .top___1Zh3U,
.Physical___2C4F_ .NewThree___3pi1H .ThreeItem___2EkLR .top___1Zh3U {
  font-weight: 400;
  color: #1a1a1a;
  font-size: 4.267vw;
  line-height: 5.6vw;
  margin: 4vw 0 1.467vw;
}

.Physical___2C4F_ .Four___1D1QB .ThreeItem___2EkLR .middle___3ixSj,
.Physical___2C4F_ .NewThree___3pi1H .ThreeItem___2EkLR .middle___3ixSj {
  font-weight: 400;
  color: #8d8e99;
  font-size: 3.467vw;
  line-height: 4.267vw;
  margin-bottom: 3.2vw;
}

.Physical___2C4F_ .Four___1D1QB .ThreeItem___2EkLR .bottom___3ELo4,
.Physical___2C4F_ .NewThree___3pi1H .ThreeItem___2EkLR .bottom___3ELo4 {
  border-top: 0.5px solid #fad4b1;
  line-height: 8vw;
  font-size: 3.733vw;
  font-weight: 400;
  color: #232323;
}

.Physical___2C4F_ .Four___1D1QB {
  margin: 0 4.267vw;
}

.Physical___2C4F_ .Four___1D1QB .ThreeItem___2EkLR {
  width: 44.4vw;
}

.Physical___2C4F_ .NewOne___18sSs {
  padding-top: 0.933vw;
}

.Physical___2C4F_ .NewOne___18sSs .OneItem___1hbOs {
  border-bottom: 0.5px solid #f9e0bf;
  height: 18.667vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 82.933vw;
  margin: 0 auto;
}

.Physical___2C4F_ .NewOne___18sSs .OneItem___1hbOs .OneItemleft___39iL8 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #1a1a1a;
  font-size: 4vw;
  line-height: 3.733vw;
}

.Physical___2C4F_ .NewOne___18sSs .OneItem___1hbOs .OneItemleft___39iL8 .middle___3ixSj {
  color: #8d8e99;
  font-size: 3.467vw;
  line-height: 4.267vw;
  margin-top: 2vw;
}

.Physical___2C4F_ .NewOne___18sSs .OneItem___1hbOs .btn___KSOJV {
  width: 17.067vw;
  height: 8.533vw;
  border-radius: 1.067vw;
  border: 1px solid #f15555;
  line-height: 8.533vw;
  text-align: center;
  color: #f15656;
  font-size: 3.733vw;
}

.Physical___2C4F_ .NewOne___18sSs .OneItem___1hbOs:last-of-type {
  border: none;
}

.Physical___2C4F_ .NewTwo___25qY4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Physical___2C4F_ .NewTwo___25qY4 .TwoItemleft___28Bsf {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #1a1a1a;
  font-size: 4vw;
}

.Physical___2C4F_ .NewTwo___25qY4 .TwoItemleft___28Bsf .middle___3ixSj {
  font-weight: 400;
  color: #8d8e99;
  font-size: 3.467vw;
  line-height: 4.267vw;
  margin-top: 2vw;
}

.Physical___2C4F_ .NewTwo___25qY4 .btn___KSOJV {
  width: 17.067vw;
  height: 8.533vw;
  background: #fff;
  border-radius: 1.067vw;
  border: 0.5px solid #ff99a4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff99a4;
  font-size: 3.733vw;
}

.Certificate___3p-U2 .Cline___2ETTY {
  display: flex;
  align-items: center;
  margin: 3.733vw 4.267vw 0;
}

.Certificate___3p-U2 .Cline___2ETTY .book___1gds9 {
  width: 18.667vw;
  height: 24.4vw;
  object-fit: cover;
  margin-right: 3.333vw;
}

.Certificate___3p-U2 .Cline___2ETTY .cli-r___3RiZ0 {
  display: flex;
  flex-direction: column;
  justify-items: center;
}

.Certificate___3p-U2 .Cline___2ETTY .cli-r___3RiZ0 .cli-t___3KUye {
  color: #1a1a1a;
  font-size: 4vw;
}

.Certificate___3p-U2 .Cline___2ETTY .cli-r___3RiZ0 .cli-m___1XuvX {
  font-weight: 400;
  color: #8d8e99;
  font-size: 3.467vw;
  line-height: 4.267vw;
  margin: 2.8vw 0 2.533vw;
}

.Certificate___3p-U2 .Cline___2ETTY .cli-r___3RiZ0 .cli-b___1MCzP {
  width: 21.333vw;
  height: 6.4vw;
  background: #fff;
  border-radius: 1.067vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3.2vw;
}

.Certificate___3p-U2 .NewThree___3GY9e {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: -3.2vw;
}

.Certificate___3p-U2 .NewThree___3GY9e .ThreeItem___2cG93 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40vw;
  height: 44.933vw;
  background: #fff;
  box-shadow: inset 0 -0.667vw 0.4vw 0 rgba(243, 184, 142, 0.5);
  border-radius: 1.067vw;
  border-top: 0.5px solid #fad4b1;
  border-bottom: 0.5px solid #fad4b1;
  margin-top: 3.2vw;
}

.Certificate___3p-U2 .NewThree___3GY9e .ThreeItem___2cG93 .cate___17iY9 {
  width: 14.533vw;
  height: 18.933vw;
  margin: 3.067vw 0 1.733vw;
}

.Certificate___3p-U2 .NewThree___3GY9e .ThreeItem___2cG93 .name___zhOYP {
  font-weight: 400;
  color: #1a1a1a;
  font-size: 4vw;
  line-height: 5.6vw;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.Certificate___3p-U2 .NewThree___3GY9e .ThreeItem___2cG93 .com___3bSAA {
  text-align: center;
  font-weight: 400;
  color: #8d8e99;
  font-size: 3.467vw;
  line-height: 4.267vw;
  margin-bottom: 1.733vw;
  width: 34.667vw;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.Certificate___3p-U2 .NewThree___3GY9e .ThreeItem___2cG93 .btn___1jJbD {
  width: 18.667vw;
  height: 6.4vw;
  background: linear-gradient(180deg, #fffbf4, #ffeed0);
  box-shadow: inset 0 -0.667vw 0.4vw 0 rgba(243, 184, 142, 0.5);
  border-radius: 1.067vw;
  border: 0.5px solid #fad4b1;
  color: #232323;
  font-size: 3.2vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  text-align: center;
}

.Certificate___3p-U2 .NewOne___Ffkki {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0 5.333vw;
}

.Certificate___3p-U2 .NewOne___Ffkki .OneItem____nrWM {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 46.667vw;
  margin-top: 5.333vw;
}

.Certificate___3p-U2 .NewOne___Ffkki .OneItem____nrWM .cate___17iY9 {
  width: 14.533vw;
  height: 18.933vw;
  margin-bottom: 1.733vw;
}

.Certificate___3p-U2 .NewOne___Ffkki .OneItem____nrWM .name___zhOYP {
  color: #1a1a1a;
  font-size: 4vw;
  line-height: 5.6vw;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.Certificate___3p-U2 .NewOne___Ffkki .OneItem____nrWM .com___3bSAA {
  text-align: center;
  font-weight: 400;
  color: #8d8e99;
  font-size: 3.467vw;
  line-height: 4.267vw;
  margin-bottom: 1.733vw;
  width: 41.333vw;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.Certificate___3p-U2 .NewOne___Ffkki .OneItem____nrWM .btn___1jJbD {
  width: 18.667vw;
  height: 6.4vw;
  background: linear-gradient(180deg, #fffbf4, #ffeed0);
  box-shadow: inset 0 -0.667vw 0.4vw 0 rgba(243, 184, 142, 0.5);
  border-radius: 1.067vw;
  border: 0.5px solid #fad4b1;
  color: #232323;
  font-size: 3.2vw;
  line-height: 6.4vw;
  margin: 0 auto;
  text-align: center;
}

.Certificate___3p-U2 .NewOne___Ffkki .OneItem____nrWM:nth-of-type(2n) {
  border-left: 0.5px solid #fad4b1;
}

.Certificate___3p-U2 .Three___3XM0N .OneItem____nrWM:nth-of-type(2n) {
  border-left: 0.5px solid #e3e3e6;
}

.Certificate___3p-U2 .Three___3XM0N .OneItem____nrWM .btn___1jJbD {
  width: 21.333vw;
  height: 6.4vw;
  background: #fff;
  border-radius: 1.067vw;
  font-size: 3.733vw;
  text-align: center;
  line-height: 6.4vw;
  box-shadow: none;
}

.Certificate___3p-U2 .NewTwo___1Z0Nw {
  display: flex;
  align-items: center;
}

.Certificate___3p-U2 .NewTwo___1Z0Nw .cate___17iY9 {
  width: 18.667vw !important;
  height: 24.4vw !important;
  margin-right: 3.333vw;
}

.Certificate___3p-U2 .NewTwo___1Z0Nw .TwoItem___1DuBs {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.Certificate___3p-U2 .NewTwo___1Z0Nw .TwoItem___1DuBs .name___zhOYP {
  color: #1a1a1a;
  font-size: 4vw;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.Certificate___3p-U2 .NewTwo___1Z0Nw .TwoItem___1DuBs .com___3bSAA {
  color: #8d8e99;
  font-size: 3.467vw;
  line-height: 4.267vw;
  margin: 2.8vw 0 2.533vw;
  max-width: 48vw;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.Certificate___3p-U2 .NewTwo___1Z0Nw .TwoItem___1DuBs .btn___1jJbD {
  width: 21.333vw;
  height: 6.4vw;
  background: #fff;
  border-radius: 1.067vw;
  border: 0.5px solid #fd88a8;
  color: #fd88a8;
  font-size: 3.733vw;
  text-align: center;
  line-height: 6.4vw;
}

.Certificate___3p-U2 .Two___3qfds {
  padding: 1.067vw 0;
}

.Certificate___3p-U2 .Two___3qfds .TwoItems___1u6IU {
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid #e3e3e6;
  height: 20.133vw;
  margin: 0 4.267vw;
}

.Certificate___3p-U2 .Two___3qfds .TwoItems___1u6IU .cate___17iY9 {
  width: 9.2vw;
  height: 12vw;
  margin-right: 2.4vw;
}

.Certificate___3p-U2 .Two___3qfds .TwoItems___1u6IU .right___1mFea {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.Certificate___3p-U2 .Two___3qfds .TwoItems___1u6IU .right___1mFea .name___zhOYP {
  display: flex;
  align-items: center;
  color: #1a1a1a;
  font-size: 4vw;
}

.Certificate___3p-U2 .Two___3qfds .TwoItems___1u6IU .right___1mFea .name___zhOYP .btn___1jJbD {
  font-weight: 400;
  font-size: 3.2vw;
  height: 4.267vw;
  border-radius: 0.533vw;
  text-align: center;
  line-height: 4.267vw;
  margin-left: 1.067vw;
  padding: 0 2vw;
}

.Certificate___3p-U2 .Two___3qfds .TwoItems___1u6IU .right___1mFea .com___3bSAA {
  color: #8d8e99;
  line-height: 4.267vw;
  font-size: 3.467vw;
  margin-top: 2.533vw;
}

.Certificate___3p-U2 .Two___3qfds .TwoItems___1u6IU:last-of-type {
  border: none;
}

.Certificate___3p-U2 .Four___1Z04Y {
  padding: 4.267vw;
}

.Certificate___3p-U2 .Four___1Z04Y .ThreeItem___2cG93 {
  border: none;
  width: 44.533vw;
  height: 44.933vw;
  background: #fff;
  border-radius: 1.067vw;
  box-shadow: none;
}

.Certificate___3p-U2 .Four___1Z04Y .ThreeItem___2cG93 .btn___1jJbD {
  color: #fff;
  box-shadow: none;
}

.Certificate___3p-U2 .Five___3HSeX {
  padding: 3.2vw 0 0;
}

.Certificate___3p-U2 .Five___3HSeX .OneItem____nrWM:nth-of-type(2n) {
  border-left: 0.5px solid #e3e3e6;
}

.Certificate___3p-U2 .Five___3HSeX .OneItem____nrWM .btn___1jJbD {
  width: 21.333vw;
  height: 6.4vw;
  background: #fff;
  border-radius: 1.067vw;
  font-size: 3.733vw;
  text-align: center;
  line-height: 6.4vw;
  box-shadow: none;
}

.Security___1-jUC {
  margin: 0 4.267vw;
}

.Security___1-jUC .SeLine___2O8f5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 400;
  color: #1a1a1a;
  font-size: 4.267vw;
  border-bottom: 0.5px solid #ededf0;
  height: 10.933vw;
}

.Security___1-jUC .SeLine___2O8f5 .SeLineL___2AH9Y {
  display: flex;
  align-items: center;
}

.Security___1-jUC .SeLine___2O8f5 .SeLineL___2AH9Y .icon___16dE9 {
  margin-right: 1.067vw;
  font-size: 4.4vw;
}

.Security___1-jUC .SeLine___2O8f5 .SeLineL___2AH9Y .iconr___3xYIY {
  margin-left: 0.933vw;
  font-size: 2.667vw;
  color: #09be89;
}

.Security___1-jUC .SeLine___2O8f5 .SeLineR___1-nxs {
  display: flex;
  align-items: center;
  font-size: 4vw;
}

.Security___1-jUC .SeLine___2O8f5 .SeLineR___1-nxs .iconrs___1lUOR {
  margin-left: 1.867vw;
  color: #b0b1b8;
}

.Security___1-jUC .SeLine___2O8f5:last-of-type {
  border: none;
}

.Security___1-jUC .creditCont___1STzw {
  width: 87.2vw;
  border-radius: 3.2vw;
  background: #fff;
  margin: 13.333vw auto;
}

.Security___1-jUC .creditCont___1STzw .creditTit___Jd6bx {
  box-sizing: content-box;
  height: 6.133vw;
  position: relative;
  font-weight: 700;
  color: #1a1a1a;
  font-size: 4.267vw;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4.533vw 0 6vw;
}

.Security___1-jUC .creditCont___1STzw .creditTit___Jd6bx .close___2wcdr {
  position: absolute;
  width: 6.133vw;
  height: 6.133vw;
  right: 6.533vw;
  color: #b0b1b8;
}

.Security___1-jUC .creditCont___1STzw .creditItem___1t_6j {
  padding-bottom: 4.267vw;
  border-bottom: 0.5px solid #ededf0;
  margin: 0 4.267vw 4.8vw;
}

.Security___1-jUC .creditCont___1STzw .creditItem___1t_6j .creditLine___2iDaT {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #8d8e99;
  font-weight: 400;
  font-size: 3.467vw;
}

.Security___1-jUC .creditCont___1STzw .creditItem___1t_6j .creditLine___2iDaT .creditLeft___1YuTH {
  display: flex;
  align-items: center;
  color: #1a1a1a;
  font-size: 4.267vw;
  font-weight: 700;
}

.Security___1-jUC .creditCont___1STzw .creditItem___1t_6j .creditLine___2iDaT .creditLeft___1YuTH img {
  width: 4.267vw;
  height: 4.267vw;
  margin-right: 2vw;
}

.Security___1-jUC .creditCont___1STzw .creditItem___1t_6j .creditGreen___2eBzf {
  font-weight: 400;
  color: #09be89;
  font-size: 4.267vw;
  margin-top: 2.133vw;
}

.main___2Urec {
  min-height: 100vh;
  background: #fff;
  overflow: hidden;
}

.main___2Urec .infoContent___83STh {
  // background: url(https://fr-static.jiazhengye.cn/bg.97fb18ab1054a148.png) no-repeat 0 0;
  background-size: 100% 100%;
  padding: 11.867vw 0 5.067vw;
  min-height: 113.333vw;
  position: relative;
  background-color: #23fdb5;
}

.main___2Urec .infoContent___83STh .finish___3MR4B {
  font-size: 3.2vw;
  font-weight: 400;
  color: #fff;
  line-height: 4.4vw;
  left: 8.933vw;
  top: 4.667vw;
  position: absolute;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 {
  // width: 93.6vw;
  min-height: 89.067vw;
  background: #fff;
  border-radius: 4.267vw;
  padding: 5.467vw;
  margin: 3.2vw;
  position: relative;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .topContent___2uXHw {
  display: flex;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .topContent___2uXHw .imgContent___1Qia7 {
  width: 31.2vw;
  height: 43.067vw;
  position: absolute;
  right: 3.2vw;
  top: -7.867vw;
  overflow: hidden;
  border-radius: 0 0 2.667vw 2.667vw;
  border-radius: 4vw 4vw 2.667vw 2.667vw;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .topContent___2uXHw .imgContent___1Qia7 .bgImg___fpXKW {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  left: 0;
  top: 0;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .topContent___2uXHw .imgContent___1Qia7 .starLevel___3QWvB {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 6.267vw;
  background: linear-gradient(135deg, #fff9eb, #feeeb8);
  color: #84532d;
  font-size: 3.2vw;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1.067vw;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .topContent___2uXHw .imgContent___1Qia7 .starLevel___3QWvB img {
  width: 3.733vw;
  height: 3.733vw;
  margin-right: 1.067vw;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .topContent___2uXHw .basicContent___QgPZS {
  height: 40vw;
  width: 60%;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .topContent___2uXHw .basicContent___QgPZS .nameBox___nin8K {
  font-weight: 500;
  color: #1a1a1a;
  display: flex;
  height: 6.667vw;
  align-items: center;
  margin-top: 3.2vw;
  margin-bottom: 4vw;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .topContent___2uXHw .basicContent___QgPZS .nameBox___nin8K h1 {
  font-size: 6.667vw;
  line-height: 6.667vw;
  margin-right: 2.133vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .topContent___2uXHw .basicContent___QgPZS .nameBox___nin8K .status___2lfi3 {
  padding: 0.8vw 1.333vw;
  background: #ff6f63;
  border-radius: 0.533vw;
  font-size: 3.2vw;
  line-height: 3.2vw;
  font-weight: 400;
  color: #fff;
  white-space: nowrap;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .topContent___2uXHw .basicContent___QgPZS .info___18IXs {
  font-size: 4vw;
  font-weight: 400;
  color: #84532d;
  line-height: 5.6vw;
  margin-top: 0.933vw;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .infoList___3ul_p {
  display: flex;
  flex-wrap: wrap;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .infoList___3ul_p .infoItem___3Pg7P {
  width: 50%;
  min-height: 5.6vw;
  font-size: 4vw;
  font-weight: 400;
  color: #1a1a1a;
  margin-top: 1.6vw;
  display: flex;
  align-items: center;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .infoList___3ul_p .infoItem___3Pg7P .circle___2yOx- {
  width: 1.733vw;
  height: 1.733vw;
  background: #fff;
  border: 0.533vw solid #e4e4e4;
  border-radius: 50%;
  margin-right: 2.133vw;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .tagList___1_EJZ {
  display: flex;
  flex-wrap: wrap;
  margin-top: 4vw;
}

.main___2Urec .infoContent___83STh .infoBox___FGFO1 .tagList___1_EJZ .tagItem___3fYIO {
  margin-top: 1.333vw;
  margin-right: 2.133vw;
  font-size: 3.2vw;
  padding: 0.8vw 1.333vw;
}

.main___2Urec .cardBox1___-sxdi {
  border-radius: 4.267vw;
  padding-top: 4.267vw;
  margin: 0 3.2vw;
}

.main___2Urec .cardBox1___-sxdi .headerBox___3w0Mo .title___Lmzky {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10.667vw;
  position: relative;
}

.main___2Urec .cardBox1___-sxdi .headerBox___3w0Mo .title___Lmzky .name___1Py85 {
  font-size: 5.333vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 700;
  color: #703020;
  margin: 0 3.2vw;
  height: 10.667vw;
  background: url(https://fr-static.jiazhengye.cn/-%20%E5%86%85%E9%83%A8%E5%A4%87%E6%B3%A8%E5%8F%8A%E7%85%A7%E7%89%87%20-@2x.643c0cbdf343c6f8.png) no-repeat 50%;
  background-size: 33.333vw 8vw;
  line-height: 10.667vw;
}

.main___2Urec .cardBox1___-sxdi .headerBox___3w0Mo .title___Lmzky .bgText___KOeHI {
  position: absolute;
  top: -1.333vw;
  left: 50%;
  transform: translateX(-50%);
  font-size: 8.533vw;
  font-family: HelveticaNeue-BoldItalic, HelveticaNeue, arial;
  font-weight: 400;
  color: #000;
  line-height: 10.4vw;
  letter-spacing: 0.667vw;
  opacity: 0.04;
}

.main___2Urec .cardBox1___-sxdi .headerBox___3w0Mo .tip___1R1jX {
  font-size: 3.2vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff4040;
  text-align: center;
}

.main___2Urec .cardBox1___-sxdi .content___KUy2C {
  background: #fff;
  box-shadow: 0 0.267vw 1.067vw 0.533vw rgba(62, 62, 62, 0.11);
  border-radius: 4.267vw;
  margin-top: 3.2vw;
}

.main___2Urec .cardBox1___-sxdi .content___KUy2C .remarkImg___2pJHF {
  padding: 2.133vw 0 4.267vw 2.267vw;
}

.main___2Urec .cardBox1___-sxdi .content___KUy2C .remark___pG3WQ {
  font-size: 4vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 5.867vw;
  padding: 4.267vw 4.267vw 0;
}

.main___2Urec .cardBox1___-sxdi .family___1nbii {
  padding: 1.067vw 5.333vw 3.2vw;
}

.main___2Urec .cardBox1___-sxdi .family___1nbii .list___2F7IE {
  display: flex;
  flex-wrap: wrap;
}

.main___2Urec .cardBox1___-sxdi .family___1nbii .item___-YmsT {
  margin-top: 3.2vw;
  width: 50%;
  display: flex;
  align-items: center;
}

.main___2Urec .cardBox1___-sxdi .family___1nbii .label___31bZu {
  font-size: 4vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5e5e66;
}

.main___2Urec .cardBox1___-sxdi .family___1nbii .value___1zuTU {
  font-size: 4vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1a1a1a;
}

.main___2Urec .cardBox1___-sxdi .family___1nbii .cenBox___AKmla {
  margin: 3.2vw 0;
  border-top: 1px solid rgba(253, 115, 137, 0.1);
}

.main___2Urec .cardBox1___-sxdi .photos___18N1B {
  padding: 2.133vw 0 4.267vw 1.733vw;
}

.main___2Urec .cardBox2___14CSc {
  background: #fe929f;
  border-radius: 4.267vw;
  padding-top: 6.533vw;
  margin: 9.6vw 3.2vw 0;
  padding-bottom: 3.2vw;
}

.main___2Urec .cardBox2___14CSc .headerBox___3w0Mo .title___Lmzky {
  height: 6.667vw;
  text-align: center;
  position: relative;
}

.main___2Urec .cardBox2___14CSc .headerBox___3w0Mo .title___Lmzky .name___1Py85 {
  font-size: 4.8vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #fff;
  line-height: 6.667vw;
}

.main___2Urec .cardBox2___14CSc .headerBox___3w0Mo .title___Lmzky .bgText___KOeHI {
  position: absolute;
  top: -1.333vw;
  left: 50%;
  transform: translateX(-50%);
  font-size: 8.533vw;
  font-family: HelveticaNeue-BoldItalic, HelveticaNeue, arial;
  font-weight: 400;
  color: #000;
  line-height: 10.4vw;
  letter-spacing: 0.667vw;
  opacity: 0.04;
}

.main___2Urec .cardBox2___14CSc .headerBox___3w0Mo .tip___1R1jX {
  font-size: 3.2vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
  text-align: center;
}

.main___2Urec .cardBox2___14CSc .content___KUy2C {
  border-radius: 4.267vw;
  background: #fffbf2;
  margin-top: 3.2vw;
}

.main___2Urec .cardBox2___14CSc .content___KUy2C.scheBox___1wyPd {
  padding: 2.667vw 4.267vw 4.267vw 2.667vw;
  display: flex;
  flex-wrap: wrap;
  margin: 0 2.133vw;
  justify-content: center;
}

.main___2Urec .cardBox2___14CSc .content___KUy2C.scheBox___1wyPd .list___2F7IE {
  position: relative;
  width: 18vw;
  height: 11.733vw;
  background: #ededf0;
  border-radius: 1.067vw;
  padding: 0.533vw;
  overflow: hidden;
  margin: 1.6vw 0 0 1.6vw;
}

.main___2Urec .cardBox2___14CSc .content___KUy2C.scheBox___1wyPd .list___2F7IE .cenBox___AKmla {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 1.067vw;
}

.main___2Urec .cardBox2___14CSc .content___KUy2C.scheBox___1wyPd .list___2F7IE .rang___3Tq28 {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: #fe929f;
  border-radius: 1.067vw;
}

.main___2Urec .cardBox2___14CSc .content___KUy2C.scheBox___1wyPd .list___2F7IE .text___2Xfyk {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  font-size: 4.8vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
}

.main___2Urec .cardBox2___14CSc .content___KUy2C.scheBox___1wyPd .list___2F7IE .change___159qq {
  color: #fff;
}

.main___2Urec .cardBox3___2xwn8 {
  background: rgba(253, 115, 137, 0.05);
  border-radius: 4.267vw;
  padding-top: 6.533vw;
  margin: 9.6vw 3.2vw 0;
  border: 0.533vw solid rgba(253, 115, 137, 0.1);
}

.main___2Urec .cardBox3___2xwn8 .headerBox___3w0Mo .title___Lmzky {
  height: 6.667vw;
  text-align: center;
  position: relative;
}

.main___2Urec .cardBox3___2xwn8 .headerBox___3w0Mo .title___Lmzky .name___1Py85 {
  font-size: 4.8vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 6.667vw;
}

.main___2Urec .cardBox3___2xwn8 .headerBox___3w0Mo .title___Lmzky .bgText___KOeHI {
  position: absolute;
  top: -1.333vw;
  left: 50%;
  transform: translateX(-50%);
  font-size: 8.533vw;
  font-family: HelveticaNeue-BoldItalic, HelveticaNeue, arial;
  font-weight: 400;
  color: #000;
  line-height: 10.4vw;
  letter-spacing: 0.667vw;
  opacity: 0.04;
}

.main___2Urec .cardBox3___2xwn8 .headerBox___3w0Mo .tip___1R1jX {
  font-size: 3.2vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1a1a1a;
  text-align: center;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C {
  border-radius: 4.267vw;
  margin-top: 3.2vw;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.userInfo___2UsAO {
  padding: 1.067vw 5.333vw 4.267vw;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.userInfo___2UsAO .list___2F7IE {
  margin-top: 3.2vw;
  display: flex;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.userInfo___2UsAO .label___31bZu {
  min-width: 17.333vw;
  line-height: 6vw;
  font-size: 4.267vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5e5e66;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.userInfo___2UsAO .value___1zuTU {
  flex: 1 1;
  font-size: 4.267vw;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #1a1a1a;
  margin-left: 2.133vw;
  word-break: break-all;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.userInfo___2UsAO .cenBorder___380Ux {
  width: 91.467vw;
  height: 1px;
  border-top: 0.5px solid #e3e3e6;
  margin: 2.133vw 0;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.userInfo___2UsAO .infoBox___FGFO1 {
  display: flex;
  flex-wrap: wrap;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.userInfo___2UsAO .infoBox___FGFO1 .item___-YmsT {
  display: flex;
  width: 50%;
  margin-top: 2.4vw;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.userInfo___2UsAO .auntBox___1RgaH {
  padding: 0.8vw 0 3.2vw;
  margin-top: 2.4vw;
  border-top: 0.5px solid #e3e3e6;
  border-bottom: 0.5px solid #e3e3e6;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.family___1nbii {
  padding: 1.067vw 5.333vw 3.2vw;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.family___1nbii .list___2F7IE {
  display: flex;
  flex-wrap: wrap;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.family___1nbii .item___-YmsT {
  margin-top: 3.2vw;
  width: 50%;
  display: flex;
  align-items: center;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.family___1nbii .label___31bZu {
  font-size: 4vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5e5e66;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.family___1nbii .value___1zuTU {
  font-size: 4vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1a1a1a;
}

.main___2Urec .cardBox3___2xwn8 .content___KUy2C.family___1nbii .cenBox___AKmla {
  margin: 3.2vw 0;
  border-top: 1px solid rgba(253, 115, 137, 0.1);
}

.main___2Urec .cardBox4___2XeA1 {
  background: #f9e0bf;
  border-radius: 4.267vw;
  padding: 5.733vw 3.2vw;
  margin-top: 8.533vw;
  position: relative;
}

.main___2Urec .cardBox4___2XeA1 .content___KUy2C {
  border-radius: 4.267vw;
  background: #fff6ef;
  margin-top: 3.2vw;
  padding-top: 8vw;
  position: relative;
}

.main___2Urec .cardBox4___2XeA1 .content___KUy2C .title___Lmzky {
  position: absolute;
  left: -2vw;
  top: -1.333vw;
  width: 35.333vw;
  height: 10.667vw;
  background: url(https://fr-static.jiazhengye.cn/19@2x.918ae961e84df834.png) no-repeat 0 0;
  background-size: 100% 100%;
  font-size: 4vw;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
}

.main___2Urec .cardBox4___2XeA1 .content___KUy2C .title___Lmzky span {
  font-size: 7.867vw;
  font-family: Helvetica-BoldOblique, Helvetica;
  font-weight: 400;
  color: #fff;
  margin-right: 3.2vw;
  margin-left: 1.067vw;
}

.main___2Urec .cardBox4___2XeA1 .content___KUy2C .title___Lmzky .bgText___KOeHI {
  position: absolute;
  top: -1.333vw;
  left: 50%;
  transform: translateX(-50%);
  font-size: 8.533vw;
  font-family: HelveticaNeue-BoldItalic, HelveticaNeue, arial;
  font-weight: 400;
  color: #000;
  line-height: 10.4vw;
  letter-spacing: 0.667vw;
  opacity: 0.04;
}

.main___2Urec .cardBox4___2XeA1 .content___KUy2C.custom___1JMlo .title___Lmzky {
  background: url('https://fr-static.jiazhengye.cn/19@2x(1).66d0fa1537366b9c.png') no-repeat 0 0;
  background-size: 100% 100%;
}

.main___2Urec .card-list___KyyS5 {
  border-top-left-radius: 4.267vw;
  border-top-right-radius: 4.267vw;
  overflow: hidden;
  margin: 5.333vw 0;
  padding: 0 3.2vw 4.267vw;
  background: linear-gradient(180deg, #23fdb5, #17bf87);
}

.main___2Urec .card-list___KyyS5 .headerBox___3w0Mo {
  margin-top: 6.533vw;
  margin-bottom: 4.267vw;
}

.main___2Urec .card-list___KyyS5 .headerBox___3w0Mo .title___Lmzky {
  height: 6.667vw;
  text-align: center;
  position: relative;
}

.main___2Urec .card-list___KyyS5 .headerBox___3w0Mo .title___Lmzky .name___1Py85 {
  font-size: 4.8vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #fff;
  line-height: 6.667vw;
}

.main___2Urec .card-list___KyyS5 .headerBox___3w0Mo .title___Lmzky .bgText___KOeHI {
  position: absolute;
  top: -1.333vw;
  left: 50%;
  transform: translateX(-50%);
  font-size: 8.533vw;
  font-family: HelveticaNeue-BoldItalic, HelveticaNeue, arial;
  font-weight: 400;
  color: #000;
  line-height: 10.4vw;
  letter-spacing: 0.667vw;
  opacity: 0.04;
}

.main___2Urec .card-list___KyyS5 .con___2VAjm {
  // width: 100vw;
  background: #fff;
  border-radius: 1.867vw;
  padding: 4.267vw 5.333vw;
  position: relative;
}

.main___2Urec .card-list___KyyS5 .con___2VAjm img {
  width: 1.733vw;
  height: 9.333vw;
}

.main___2Urec .card-list___KyyS5 .con___2VAjm .left___1GmIl {
  position: absolute;
  top: -6vw;
  left: 9.867vw;
}

.main___2Urec .card-list___KyyS5 .con___2VAjm .right___idEOZ {
  position: absolute;
  top: -6vw;
  right: 10.667vw;
}

.main___2Urec .card-list___KyyS5 .con___2VAjm .title___Lmzky {
  font-size: 4vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 5.6vw;
}

.main___2Urec .card-list___KyyS5 .con___2VAjm .text___2Xfyk {
  font-size: 3.733vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5e5e66;
  line-height: 5.867vw;
  margin-top: 1.067vw;
}

.main___2Urec .card-list___KyyS5 .conBox___11S5A>div:not(:first-child) {
  margin-top: 2.667vw;
}

.main___2Urec .bottom___1m3rr {
  font-size: 3.733vw;
  font-weight: 400;
  color: #8d8e99;
  line-height: 5.333vw;
  text-align: center;
  margin: 4.267vw 0;
}

.main___2Urec .bottom___1m3rr p {
  margin-bottom: 0;
}

.download___oK09P {
  position: fixed;
  right: 4vw;
  bottom: 4vw;
  width: 8vw;
  height: 8vw;
  background: rgba(0, 0, 0, 0.15);
  opacity: 1;
  z-index: 1000;
}

.download___oK09P img {
  width: 100%;
  height: 100%;
}

.pd-10___1dBEL {
  padding-bottom: 1.333vw;
}
</style>

<style lang="scss" scoped>
.home {
  .img-model {
    margin-top: 20px;
    text-align: center;

    .title-text {
      font-size: 4.8vw;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      // color: #fff;
      line-height: 6.667vw;
    }

    .img-wrapper {
      background: rgba(253, 115, 137, 0.05);
      border: 0.533vw solid rgba(253, 115, 137, 0.1);
      border-radius: 4.267vw;
      display: flex;
      flex-wrap: wrap;
      padding: 3vw;
      margin: 3vw;

      // justify-content: space-around;
      .img-view {
        width: 22vw;
        height: 100px;
        margin-left: 3vw;
        margin-right: 3vw;
        margin-top: 3vw;
        object-fit: cover;
      }

      .video-view {
        position: relative;
        width: 22vw;
        height: 100px;
        margin-left: 3vw;
        margin-right: 3vw;
        margin-top: 3vw;

        .img-icon {
          position: relative;
          top: 30px;
          left: 1vw;
          height: 40px;
          width: 40px;
          z-index: 1;
        }

        .img-view {
          position: absolute;
          top: 0;
          left: 0;
          width: 25vw;
          height: 100px;
          margin: 0px;
          object-fit: cover;
        }
      }
    }

    /* 最后一项margin-right:auto */
    // .img-wrapper:last-child {
    //   margin-right: auto;
    // }
  }

  // .video-box {
  //   position: fixed;
  //   height: 100vh;
  //   height: 100vh;
  // }
  .video-wrapper {
    width: 80vw;
    height: 80vh;

    video {
      height: 100%;
      width: 100%;
    }
  }

  .lianxi {
    position: fixed;
    bottom: 0;
    height: 50px;
    width: 100vw;
    background-color: #e15320;
    color: #fff;
    z-index: 2;

    a {
      color: #fff;
      font-size: 18px;
      line-height: 50px;
      text-align: center;
      width: 100%;
      display: block;
    }
  }
}
</style>
